jQuery(($) => {

    if ($('.o-location-slider-hero')[0]) {
        var imageSlides      = $('.o-location-slider-hero__image-slides'),
            arrowsNavigation = $('.o-location-slider-hero__arrows-navigation'),
            dotsNavigation   = $('.o-location-slider-hero__dots-navigation');

        $('.o-location-slider-hero__block-slides').slick({
            speed: 600,
            swipe: false,
            asNavFor: imageSlides,
            cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
            fade: true,
            arrows: true,
            dots: true,
            appendArrows: arrowsNavigation,
            appendDots: dotsNavigation
        }).on('afterChange', function (event, slick, currentSlide, nextSlide) {
            var slideCurrent = $('.slick-current');

            slideCurrent.addClass('activated');
        });

        if ($('.o-location-slider-hero__image-slides')[0]) {
            $('.o-location-slider-hero__image-slides').slick({
                speed: 600,
                cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
                arrows: false,
                fade: true,
            });
        };
    }
});